import * as React from 'react'

import { ImageTextBlockNew } from 'components/image-text-block-new/ImageTextBlockNew'
import { Text, TextName } from 'sdk'

import type { SoundcorePartnerProductCmsContent } from 'core/services/cms/interfaces'

import classes from './style.module.scss'


interface PartnerProductsProps {
  products: SoundcorePartnerProductCmsContent[]
}

export const PartnerProducts: React.FC<PartnerProductsProps> = ({ products }) => {
  return (
    <section className={classes.content}>
      {products.map(({ title, imageDesktopUrl, imageMobileUrl, description, buttonUrl, buttonText }, index) => (
        <ImageTextBlockNew
          key={title}
          imageDesktop={imageDesktopUrl}
          imageMobile={imageMobileUrl}
          title={title}
          reverse={index % 2 === 1}
          buttonLink={buttonUrl}
          buttonText={buttonText}
          aspectRatio='1/1'
        >
          <Text type={TextName.Text}>{description}</Text>
        </ImageTextBlockNew>
      ))}
    </section>
  )
}
